module.exports = __webpack_public_path__ + "static/img/player_head_7.241781e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_7.jpg
// module id = WlGo
// module chunks = 1